'use client';
import { SessionContext } from '@benzinga/session-context';
import { Watchlist, WatchlistManager } from '@benzinga/watchlist-manager';
import React from 'react';

import { Modal } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';

interface Props {
  closeModal: () => void;
  watchlist?: Watchlist;
}

export const WatchlistDelete: React.FC<Props> = props => {
  const session = React.useContext(SessionContext);

  const doDelete = React.useCallback(() => {
    if (props.watchlist) {
      session.getManager(WatchlistManager).removeWatchlist(props.watchlist);
    }
    props.closeModal();
  }, [props, session]);

  const closeModal = React.useCallback(() => {
    const closeModal = props.closeModal;
    closeModal();
  }, [props.closeModal]);

  if (props.watchlist) {
    return (
      <Modal
        onClose={closeModal}
        size={{ alert: true }}
        title={
          <ModalTitleSpan>
            Delete <span className="u-primaryText pre">{props.watchlist.name}</span>
          </ModalTitleSpan>
        }
      >
        <div className="Modal-content">
          <p className="pre" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            Are you sure you want to delete {props.watchlist.name}?
          </p>
          <div className="Modal-proceed">
            <button className="Button Button--text" onClick={closeModal}>
              Cancel
            </button>
            <button autoFocus className="Button Button--primary" data-test="delete-watchlist" onClick={doDelete}>
              Delete Watchlist
            </button>
          </div>
        </div>
      </Modal>
    );
  }
  return null;
};

const ModalTitleSpan = styled.span`
  max-width: 100%;
  vertical-align: bottom;
  .u-primaryText {
    display: inline-block;
    max-width: 90%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: inherit;
  }
`;
